import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SectionHeader, Pill } from "@/components/Brand";
import { Lock, Unlock, ChevronRight, MapPin, Building2, ClipboardList } from "lucide-react";

export default function CandidateWards() {
  const [wards, setWards] = useState([]);
  useEffect(() => {
    api.get("/candidate/wards").then((r) => setWards(r.data));
  }, []);
  return (
    <div>
      <SectionHeader
        eyebrow="Campaign Intelligence"
        title="Wards marketplace"
      />
      <p className="text-sm text-slate-600 -mt-3 mb-6 max-w-2xl">
        Preview limited data on every ward. Purchase a ward to unlock full
        analytics, voter demographics, sentiment, and downloadable reports.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {wards.map((w) => (
          <div key={w.id} className="wi-card p-5 flex flex-col gap-4" data-testid={`candidate-ward-${w.name.toLowerCase()}`}>
            <div className="flex items-start justify-between">
              <div>
                <Pill tone="blue">{w.district}</Pill>
                <div className="mt-2 text-lg font-semibold text-slate-900">{w.name}</div>
                <div className="data-label mt-0.5">Ward #{w.number}</div>
              </div>
              {w.unlocked ? (
                <Pill tone="green"><Unlock size={10} className="inline mr-0.5" /> Unlocked</Pill>
              ) : (
                <Pill tone="neutral"><Lock size={10} className="inline mr-0.5" /> Locked</Pill>
              )}
            </div>
            <div className="grid grid-cols-3 gap-2 text-center">
              <Mini icon={Building2} label="Booths" value={w.booth_count} />
              <Mini icon={ClipboardList} label="Surveys" value={w.survey_count} />
              <Mini icon={MapPin} label="Status" value="Live" />
            </div>
            <Link
              to={`/candidate/wards/${w.id}`}
              data-testid={`view-report-${w.name.toLowerCase()}`}
              className="inline-flex items-center justify-center gap-1.5 w-full py-2.5 rounded-md bg-slate-900 text-white text-sm font-medium hover:bg-slate-800"
            >
              {w.unlocked ? "Open report" : "Preview & purchase"} <ChevronRight size={14} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

function Mini({ icon: Icon, label, value }) {
  return (
    <div className="p-2 bg-slate-50 rounded-md">
      <Icon size={12} className="text-slate-400 mx-auto" />
      <div className="data-label text-[10px] mt-1">{label}</div>
      <div className="metric-value text-sm mt-0.5">{value}</div>
    </div>
  );
}
